export { keydownHandler, useKeydownHandler } from './decorators/keydownHandler';
export { HotkeyCommand, Hotkeys } from './types/HotkeyCommand';
export {
    default as addGlobalHotkey,
    GlobalHotkeyOptions,
    useGlobalHotkey,
} from './utils/addGlobalHotkey';
export { default as fixUpHotkeyCommand } from './utils/fixupHotkeyCommand';
